import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject, PropTypes as MobxPropTypes } from 'mobx-react';
import { FilterOption } from 'apps/find-designers/propTypes';
import { Pill } from '@99designs/common/components/Pill';
import { Button } from '@99designs/common/components/Button';
import { bemComponent } from '@99designs/common/utils/app';
import { FormattedMessage, FormattedNumber } from 'react-intl';

const PillGroup = bemComponent('pill-group', 'PillGroup');
const PillGroupItem = bemComponent('pill-group__item', 'PillGroupItem');

const MAX_DESIGNERS = 3000;

class ResultsOverview extends Component {
    constructor() {
        super();

        this.resultCount = this.resultCount.bind(this);
    }

    clearAllButton() {
        if (this.props.filterStore.selectedFilterOptions.length > 1) {
            return (
                <Button
                    type="button"
                    variations={['link']}
                    onClick={this.props.onReset}
                    data-clear-all
                >
                    <FormattedMessage id="clear_all_button" />
                </Button>
            );
        }

        return null;
    }

    resultCount() {
        const results = this.props.totalResults;
        return results >= MAX_DESIGNERS ? (
            <span>
                <FormattedNumber value={results} />+
            </span>
        ) : (
            <FormattedNumber value={results} />
        );
    }

    filterSummary() {
        return (
            <div>
                <PillGroup variations={['no-margin', 'inline-block', 'offset-right']}>
                    {this.props.filterStore.selectedFilterOptions.map(option => (
                        <PillGroupItem key={`${option.name}-${option.value}`}>
                            <Pill variations={['tag', 'deletable']}>
                                {option.title}
                                <button
                                    type="button"
                                    className="pill__delete"
                                    name={option.name}
                                    value={option.value}
                                    onClick={this.props.onClear}
                                />
                            </Pill>
                        </PillGroupItem>
                    ))}
                </PillGroup>
                {this.clearAllButton()}
            </div>
        );
    }

    countSummary() {
        if (!this.props.filterStore.selectedFilterOptions.length) return null;

        const { totalResults } = this.props;

        if (totalResults === 0) {
            return <FormattedMessage id="result_summary_none" />;
        } else if (totalResults === 1) {
            return <FormattedMessage id="result_summary_one" />;
        }

        return (
            <FormattedMessage
                id="result_summary_other"
                values={{
                    designerCount: this.resultCount(),
                }}
            />
        );
    }

    render() {
        return (
            <div className="results-overview">
                <div className="results-overview__count">{this.countSummary()}</div>
                <div className="results-overview__filter-summary">{this.filterSummary()}</div>
            </div>
        );
    }
}

ResultsOverview.propTypes = {
    filterStore: PropTypes.shape({
        clearFilterOption: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        currentQueryString: PropTypes.string.isRequired,
        selectedFilterOptions: PropTypes.oneOfType([
            MobxPropTypes.observableArray,
            PropTypes.arrayOf(FilterOption),
        ]).isRequired,
    }).isRequired,
    totalResults: PropTypes.number.isRequired,
    onReset: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
};

export default inject('filterStore')(observer(ResultsOverview));



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/ResultsOverview.jsx